import { createPortal } from 'react-dom';
import { motion, AnimatePresence } from 'motion/react';

interface DetailSheetProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

export default function DetailSheet({ open, onClose, children }: DetailSheetProps) {
  return createPortal(
    <AnimatePresence>
      {open && (
        <div className="pp-sheet-overlay" onClick={onClose}>
          <motion.div
            className="pp-sheet"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
            onClick={e => e.stopPropagation()}
          >
            <div className="pp-sheet-handle" />
            {children}
          </motion.div>
        </div>
      )}
    </AnimatePresence>,
    document.body
  );
}
